<template>
  <el-collapse v-model="activeNames" @change="handleChange">
    <el-collapse-item name="influencers" :disabled="count === 0">
      <div class="box flex gaps title" slot="title">
        <div class="box flex center"><i class="icon icon-influence"></i></div>
        <div class="box grow">{{ title }}</div>
        <div class="box count">{{ count }}</div>
        <div class="box">&nbsp;</div>
      </div>
      <div
        v-for="trail in influence"
        class="influence-trails flex cursor-pointer"
        :key="trail.id"
        @click="enableClickState ? addActiveClass(trail) : false"
      >
        <div class="box grow flex column">
          <div class="flex box gaps">
            <div class="box flex left center" style="width: 16px;">
              <div class="box color-block" :class="`${trail.riskLevel ? trail.riskLevel.level : ''}-risk-color`"></div>
            </div>
            <div class="box">
              <strong @click="openLink(trail)">{{ trail.title }}</strong>
            </div>
            <div class="box" v-if="trail.attackId">
              <span @click="openLink(trail)">
                <i class="material-icons" style="vertical-align: text-bottom">open_in_new</i>
              </span>
            </div>
          </div>
          <div class="flex box gaps dwell-time" v-show="trail.dwellTime">
            <div class="box" style="width: 16px;">&nbsp;</div>
            <span class="box">{{ trail.riskScore ? trail.riskScore : trail.scoreContribution }}</span>
            <span class="box">{{ trail.dwellTime }}</span>
          </div>
        </div>
        <template v-if="!trail.active">
          <div class="box flex gaps">
            <template v-if="trail.numberOfHosts">
              <div class="box flex column">
                <span class="box icon icon-hosts"></span>
                <span class="box top label">{{ trail.numberOfHosts || 0 }}</span>
              </div>
              <div class="box flex column">
                <span class="box icon icon-lat-movement"></span>
                <span class="box top label">{{ trail.numberOfLateralMovements || 0 }}</span>
              </div>
              <div class="box flex column">
                <span class="box icon icon-detections"></span>
                <span class="box top label">{{ trail.numberOfDetections || 0 }}</span>
              </div>
            </template>
          </div>
        </template>
        <template v-if="enableClickState && trail.active">
          <div class="box flex gaps">
            <div class="box flex">
              <div class="cell">{{ `${currIndex}/${trail.count}` }}</div>
              <el-divider direction="vertical"></el-divider>
            </div>
            <div class="box flex">
              <i
                class="material-icons"
                :class="{ disabled: currIndex === 1 }"
                @click.stop.prevent="currIndex !== 1 ? selectBack(trail) : false"
                >expand_less</i
              >
              <i
                class="material-icons"
                :class="{ disabled: currIndex === trail.count }"
                @click.stop.prevent="currIndex !== trail.count ? selectNext(trail) : false"
                >expand_more</i
              >
            </div>
            <div class="box flex">
              <span @click.stop.prevent="removeActiveClass(trail)"> <i class="far fa-times"></i> </span>
            </div>
          </div>
        </template>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: 'InfluencerList',
  props: {
    title: { default: '', type: [String] },
    count: { default: 0, type: [Number, String] },
    tableId: { default: '', type: [String] },
    enableClickState: { default: true, type: [Boolean] },
    influence: {
      default: () => {
        return {}
      },
      type: [Object, Array]
    }
  },
  data () {
    return {
      viewHeight: 50,
      activeNames: [],
      currIndex: 0,
      ActionEnum: {
        ADD: 'add',
        REMOVE: 'remove'
      }
    }
  },
  methods: {
    handleChange (val) {
      if (val.length > 0) {
        this.viewHeight = this.$el.parentElement.clientHeight - 365 - 50
      } else {
        this.viewHeight = 50
      }
    },
    highlightRow (index, title, action = this.ActionEnum.ADD, highlightClass) {
      let trailTableElem = window.document.getElementById(this.tableId)
      title = title.replace(/[:.]/g, '_')
      try {
        let influencedRowElems = trailTableElem.querySelectorAll(`.influencedby-count_${index}_${title}`)
        if (influencedRowElems) {
          influencedRowElems.forEach(row => {
            let parentRow = row.closest('.el-table__row')
            if (action === this.ActionEnum.ADD) {
              parentRow.classList.add(...highlightClass)
            } else {
              parentRow.classList.remove(...highlightClass)
            }
          })
          influencedRowElems[0].scrollIntoView({
            behavoir: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          })
        }
      } catch (error) {
        console.log(true)
      }
    },
    addActiveClass (trail) {
      // check if same selection is made
      // if true, do nothing
      let activeTrail = _.find(this.influence, { active: true })
      if (activeTrail && activeTrail.id === trail.id) {
        return false
      }
      this.currIndex = 0
      // remove active from other selections
      this.influence.forEach(eaInfluence => {
        this.removeActiveClass(eaInfluence)
      })
      this.$set(trail, 'active', true)
      // highlight all influenced by rows
      for (let idx = 0; idx < trail.count; idx++) {
        this.highlightRow(idx + 1, trail.title, this.ActionEnum.ADD, ['influenceby'])
      }

      // select the first occurence of this influencer trail in the ioc trail table
      this.highlightRow(++this.currIndex, trail.title, this.ActionEnum.ADD, ['current-influencer'])
    },
    selectBack (trail) {
      // lift highlight from current row
      this.highlightRow(this.currIndex, trail.title, this.ActionEnum.REMOVE, ['current-influencer'])

      // add highlight to previous row
      this.highlightRow(--this.currIndex, trail.title, this.ActionEnum.ADD, ['current-influencer'])
    },
    selectNext (trail) {
      // lift highlight from current row
      this.highlightRow(this.currIndex, trail.title, this.ActionEnum.REMOVE, ['current-influencer'])

      // add highlight to previous row
      this.highlightRow(++this.currIndex, trail.title, this.ActionEnum.ADD, ['current-influencer'])
    },
    removeActiveClass (trail) {
      this.currIndex = 0
      this.$set(trail, 'active', false)
      for (let idx = 0; idx < trail.count; idx++) {
        this.highlightRow(idx + 1, trail.title, this.ActionEnum.REMOVE, ['influenceby', 'current-influencer'])
      }
    },
    openLink (trail) {
      console.log('test')
      let routeData = this.$router.resolve({
        name: 'attack-track-details',
        params: { trailId: trail.id }
      })
      window.open(routeData.href, '_blank')
    }
  },
  watch: {
    influence: function (newVal, oldVal) {
      if (newVal !== oldVal && !_.isUndefined(newVal)) {
        this.handleChange(0)
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/text.css';
@import 'assets/styles/icon.css';

.el-collapse {
  border-top: 2px solid #e2e6e9;
  border-bottom: none;
}

>>> .el-collapse-item {
  .title {
    color: #444444;
    font-size: 12px;
    text-transform: uppercase;
    width: 100%;

    .count {
      font-size: 13px;
    }
  }

  .icon {
    height: 16px;
    width: 16px;
    mask-size: 100% auto;
    mask-repeat: no-repeat;
    mask-position: center;
  }

  .influence-trails {
    margin: 0 0 10px 0;
    color: #666666;

    .label {
      text-align: center;
    }

    .dwell-time {
      color: #999999;
      font-size: 11px;
    }
  }

  .material-icons {
    font-size: 16px;
    color: var(--aluminum-400);
  }

  .el-collapse-item__header {
    padding: 0 0 0 10px;
    height: 40px;
    line-height: 40px;
    border: none;
  }

  .el-collapse-item__wrap {
    padding: 0;
    border: none;
  }

  .el-collapse-item__content {
    padding: 10px 35px 10px 30px;
    /* border-top: solid 1px #ebeef5; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/list/InfluencerList.vue